import { render, staticRenderFns } from "./automatic-record-list.vue?vue&type=template&id=528b703d"
import script from "./automatic-record-list.vue?vue&type=script&lang=js"
export * from "./automatic-record-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports